import {
   Button,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalFooter,
   ModalBody,
   ModalCloseButton,
   useColorModeValue,
   Grid,
   GridItem,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBrand } from '../../../../redux/actions/brand';
import { getCategory } from '../../../../redux/actions/category';
import { getSeries } from '../../../../redux/actions/series';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { RAM_TYPE, STORAGE_TYPE } from '../../../../variables/company';
import { getColor } from '../../../../redux/actions/color';
import { getReportSerialWiseHistory } from '../../../../redux/actions/reports';
import { useUser } from 'contexts';
import { getDaybook } from '../../../../redux/actions/daybook';
import { getAccount } from '../../../../redux/actions/account';
import { getItems } from '../../../../redux/actions/item';
import { useGlobal } from 'contexts';
import { getWarehouse } from '../../../../redux/actions/warehouse';
import { getCities } from '../../../../redux/actions/city';
import { getStates } from '../../../../redux/actions/state';
import MultiSelectDropdown from 'components/ui/MultiSelectDropdown';
import AddEditForm from '../../masters/Pages/AllAccountMaster/AddEditFormForAccount';
import warehouseForm from '../../masters/Pages/WarehouseMaster/WarehouseMasterForm';
import ColorMasterForm from '../../masters/Pages/ColorMaster/ColorMasterForm';
import SeriesMasterForm from '../../masters/Pages/SeriesMaster/SeriesMasterForm';
import CategoryMasterForm from '../../masters/Pages/CategoryMaster/CategoryMasterForm';
import BrandMasterForm from '../../masters/Pages/BrandMaster/BrandMasterForm';
import ItemForm from '../../masters/Pages/ItemMaster/ItemMasterForm';
import DaybookForm from '../../masters/Pages/DaybookMaster/DaybookForm';

function ItemSerialWiseHistory({ isOpen, onClose, companyIds, fromDate, toDate, onApply }) {
   const { user } = useUser();
   const dispatch = useDispatch();
   const { userGlobalSettingsData } = useGlobal();
   const textColor = useColorModeValue('#9E9E9E', 'white');
   const isColorMode = useColorModeValue(true, false);

   // Redux selectors
   const brandData = useSelector((state) => state.brand.list || []);
   const categoryData = useSelector((state) => state.category.list || []);
   const seriesData = useSelector((state) => state.series.list || []);
   const colorData = useSelector((state) => state.color.list || []);
   const accountData = useSelector((state) => state.account.list || []);
   const itemData = useSelector((state) => state.item.data || []);
   const daybookData = useSelector((state) => state.daybook.list || []);
   const cityData = useSelector((state) => state.city.list || []);
   const stateData = useSelector((state) => state.state.list || []);
   const warehouseData = useSelector((state) => state?.warehouse?.list || []);

   // Global settings
   const globalSettingAcc = userGlobalSettingsData?.[0]?.askCompany?.account;
   const shouldShowCompanyDropdownAcc = globalSettingAcc || false;
   const globalSettingDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook;
   const shouldShowCompanyDropdownDaybook = globalSettingDaybook || false;
   const globalSettingItem = userGlobalSettingsData?.[0]?.askCompany?.item;
   const shouldShowCompanyDropdownItem = globalSettingItem || false;
   const globalSettingBrand = userGlobalSettingsData?.[0]?.askCompany?.brand;
   const shouldShowCompanyDropdownBrand = globalSettingBrand || false;
   const globalSettingCategory = userGlobalSettingsData?.[0]?.askCompany?.category;
   const shouldShowCompanyDropdownCategory = globalSettingCategory || false;
   const globalSettingSeries = userGlobalSettingsData?.[0]?.askCompany?.series;
   const shouldShowCompanyDropdownSeries = globalSettingSeries || false;
   const globalSettingColor = userGlobalSettingsData?.[0]?.askCompany?.color;
   const shouldShowCompanyDropdownColor = globalSettingColor || false;
   const globalSettingState = userGlobalSettingsData?.[0]?.askCompany?.state;
   const shouldShowCompanyDropdownState = globalSettingState || false;
   const globalSettingCity = userGlobalSettingsData?.[0]?.askCompany?.city;
   const shouldShowCompanyDropdownCity = globalSettingCity || false;
   const globalSettingWarehouse = userGlobalSettingsData?.[0]?.askCompany?.warehouse;
   const shouldShowCompanyDropdownWarehouse = globalSettingWarehouse || false;

   // Load static data once
   useEffect(() => {
      dispatch(getStates());
      dispatch(getCities());
      dispatch(getWarehouse({}));
   }, [dispatch]);

   useEffect(() => {
      if (isOpen) {
         dispatch(
            getBrand({
               ...(shouldShowCompanyDropdownBrand &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getCategory({
               ...(shouldShowCompanyDropdownCategory &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getSeries({
               ...(shouldShowCompanyDropdownSeries &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getColor({
               ...(shouldShowCompanyDropdownColor &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getItems({
               companyId: user.loginhistory.companyId,
               ...(shouldShowCompanyDropdownItem &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
               status: true,
            }),
         );
         dispatch(
            getAccount({
               compId: user?.loginhistory?.companyId,
               status: true,
               ...(shouldShowCompanyDropdownAcc &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getDaybook({
               companyId: user.loginhistory.companyId,
               ...(shouldShowCompanyDropdownDaybook &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
      }
   }, [
      companyIds,
      dispatch,
      isOpen,
      shouldShowCompanyDropdownAcc,
      shouldShowCompanyDropdownBrand,
      shouldShowCompanyDropdownCategory,
      shouldShowCompanyDropdownColor,
      shouldShowCompanyDropdownDaybook,
      shouldShowCompanyDropdownItem,
      shouldShowCompanyDropdownSeries,
      user,
   ]);

   const initialFormData = {
      colorIds: [],
      ram: '',
      seriesIds: [],
      categoryIds: [],
      brandIds: [],
      storage: '',
      accountIds: [],
      itemIds: [],
      daybookIds: [],
      stateIds: [],
      cityIds: [],
      warehouseIds: [],
   };

   const [formData, setFormData] = useState(initialFormData);

   // Handler functions
   const handleBrandChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, brandIds: selectedValues || [] }));
   };

   const handleCategoryChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, categoryIds: selectedValues || [] }));
   };

   const handleSeriesChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, seriesIds: selectedValues || [] }));
   };

   const handleColorChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, colorIds: selectedValues || [] }));
   };

   const handleAccountChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, accountIds: selectedValues || [] }));
   };

   const handleItemChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, itemIds: selectedValues || [] }));
   };

   const handleDaybookChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, daybookIds: selectedValues || [] }));
   };

   const handleStateChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, stateIds: selectedValues || [] }));
   };

   const handleCityChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, cityIds: selectedValues || [] }));
   };

   const handleWarehouseChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, warehouseIds: selectedValues || [] }));
   };

   const handleInputChange = (name, value) => {
      setFormData((prev) => ({
         ...prev,
         [name]: value,
      }));
   };

   // Helper function to check if a value has content
   const hasValue = (value) => {
      if (Array.isArray(value)) {
         return value.length > 0;
      }
      return value !== '' && value !== null && value !== undefined;
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      onApply();
      onClose();

      // Base payload with required fields
      const payload = {
         companyIds: companyIds.toString(),
         //  fromDate: fromDate,
         //  toDate: toDate,
      };

      // Only add fields that have values
      if (hasValue(formData.colorIds)) {
         payload.colorIds = formData.colorIds.toString();
      }

      if (hasValue(formData.ram)) {
         payload.rams = formData.ram.toString();
      }

      if (hasValue(formData.seriesIds)) {
         payload.seriesIds = formData.seriesIds.toString();
      }

      if (hasValue(formData.categoryIds)) {
         payload.categoryIds = formData.categoryIds.toString();
      }

      if (hasValue(formData.brandIds)) {
         payload.brandIds = formData.brandIds.toString();
      }

      if (hasValue(formData.storage)) {
         payload.storages = formData.storage.toString();
      }

      if (hasValue(formData.accountIds)) {
         payload.accIds = formData.accountIds.toString();
      }

      if (hasValue(formData.itemIds)) {
         payload.itemIds = formData.itemIds.toString();
      }

      if (hasValue(formData.daybookIds)) {
         payload.daybookIds = formData.daybookIds.toString();
      }

      if (hasValue(formData.stateIds)) {
         payload.stateIds = formData.stateIds.toString();
      }

      if (hasValue(formData.cityIds)) {
         payload.cityIds = formData.cityIds.toString();
      }

      if (hasValue(formData.warehouseIds)) {
         payload.warehouseIds = formData.warehouseIds.toString();
      }

      dispatch(getReportSerialWiseHistory(payload));
      onClose();
   };

   const handleClear = () => {
      // Reset all form fields to initial state
      setFormData(initialFormData);

      // Create payload with only required fields (no filters)
      const payload = {
         companyIds: companyIds.toString(),
         //  fromDate: fromDate,
         //  toDate: toDate,
      };

      // Dispatch with cleared filters
      dispatch(getReportSerialWiseHistory(payload));
   };

   return (
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
         <ModalOverlay />
         <ModalContent as="form" onSubmit={handleSubmit}>
            <ModalHeader>Stock Filter</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
               <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                  {/* Account Dropdown */}
                  <GridItem>
                     {/* {renderDynamicDropdown(
                        'accountid',
                        'Account',
                        accountData,
                        {
                           value: formData.accountIds,
                           onChange: handleAccountChange,
                           showCustomNoOptions: true,
                           openfrom: 'account',
                        },
                        {},
                        textColor,
                        false,
                        'Select Account',
                        true,
                        undefined,
                        true,
                     )} */}
                     <MultiSelectDropdown
                        label="Account"
                        options={accountData}
                        value={formData.accountIds}
                        onChange={handleAccountChange}
                        placeholder="Select Account"
                        isRequired={true}
                        showAddButton={true}
                        onAddNew={(value) => console.log("handleAddNew", value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={AddEditForm}
                        error={""}
                     />
                  </GridItem>

                  {/* Daybook Dropdown */}
                  <GridItem>
                     {/* {renderDynamicDropdown(
                        'daybookid',
                        'Daybook',
                        daybookData,
                        {
                           value: formData.daybookIds,
                           onChange: handleDaybookChange,
                           showCustomNoOptions: true,
                           openfrom: 'daybook',
                        },
                        {},
                        textColor,
                        false,
                        'Select Daybook',
                        true,
                        undefined,
                        true,
                     )} */}
                     <MultiSelectDropdown
                        label="Daybook"
                        options={daybookData}
                        value={formData.daybookIds}
                        onChange={handleDaybookChange}
                        placeholder="Select Daybook"
                        isRequired={true}
                        showAddButton={true}
                        onAddNew={(value) => console.log('handleAddNew', value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={DaybookForm}
                        error={''}
                     />
                  </GridItem>

                  {/* Item Dropdown */}
                  <GridItem>
                     {/* {renderDynamicDropdown(
                        'itemid',
                        'Item',
                        itemData,
                        {
                           value: formData.itemIds,
                           onChange: handleItemChange,
                           showCustomNoOptions: true,
                           openfrom: 'item',
                        },
                        {},
                        textColor,
                        false,
                        'Select Item',
                        true,
                        undefined,
                        true,
                     )} */}
                     <MultiSelectDropdown
                        label="Item"
                        options={itemData}
                        value={formData.itemIds}
                        onChange={handleItemChange}
                        placeholder="Select Item"
                        isRequired={true}
                        showAddButton={true}
                        onAddNew={(value) => console.log('handleAddNew', value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={ItemForm}
                        error={''}
                     />
                  </GridItem>

                  {/* Brand Dropdown */}
                  <GridItem>
                     {/* {renderDynamicDropdown(
                        'brandid',
                        'Brand',
                        brandData,
                        {
                           value: formData.brandIds,
                           onChange: handleBrandChange,
                           showCustomNoOptions: true,
                           openfrom: 'brand',
                        },
                        {},
                        textColor,
                        true,
                        'Select Brand',
                        false,
                        undefined,
                        true,
                     )} */}
                     <MultiSelectDropdown
                        label="Brand"
                        options={brandData}
                        value={formData.brandIds}
                        onChange={handleBrandChange}
                        placeholder="Select Brand"
                        isRequired={true}
                        showAddButton={true}
                        onAddNew={(value) => console.log('handleAddNew', value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={BrandMasterForm}
                        error={''}
                     />
                  </GridItem>

                  {/* Category Dropdown */}
                  <GridItem>
                     {/* {renderDynamicDropdown(
                        'categoryid',
                        'Category',
                        categoryData,
                        {
                           value: formData.categoryIds,
                           onChange: handleCategoryChange,
                           showCustomNoOptions: true,
                           openfrom: 'category',
                        },
                        {},
                        textColor,
                        false,
                        'Select Category',
                        true,
                        undefined,
                        true,
                     )} */}
                     <MultiSelectDropdown
                        label="Category"
                        options={categoryData}
                        value={formData.categoryIds}
                        onChange={handleCategoryChange}
                        placeholder="Select Category"
                        isRequired={true}
                        showAddButton={true}
                        onAddNew={(value) => console.log('handleAddNew', value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={CategoryMasterForm}
                        error={''}
                     />
                  </GridItem>

                  {/* Series Dropdown */}
                  <GridItem>
                     {/* {renderDynamicDropdown(
                        'seriesId',
                        'Series',
                        seriesData,
                        {
                           value: formData.seriesIds,
                           onChange: handleSeriesChange,
                           showCustomNoOptions: true,
                           openfrom: 'series',
                        },
                        {},
                        textColor,
                        false,
                        'Select Series',
                        true,
                        undefined,
                        true,
                     )} */}
                     <MultiSelectDropdown
                        label="Series"
                        options={seriesData}
                        value={formData.seriesIds}
                        onChange={handleSeriesChange}
                        placeholder="Select Series"
                        isRequired={true}
                        showAddButton={true}
                        onAddNew={(value) => console.log('handleAddNew', value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={SeriesMasterForm}
                        error={''}
                     />
                  </GridItem>

                  {/* Color Dropdown */}
                  <GridItem>
                     {/* {renderDynamicDropdown(
                        'colorId',
                        'Color',
                        colorData,
                        {
                           value: formData.colorIds,
                           onChange: handleColorChange,
                           showCustomNoOptions: true,
                           openfrom: 'color',
                        },
                        {},
                        textColor,
                        false,
                        'Select Color',
                        true,
                        undefined,
                        true,
                     )} */}
                     <MultiSelectDropdown
                        label="Color"
                        options={colorData}
                        value={formData.colorIds}
                        onChange={handleColorChange}
                        placeholder="Select Color"
                        isRequired={true}
                        showAddButton={true}
                        onAddNew={(value) => console.log('handleAddNew', value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={ColorMasterForm}
                        error={''}
                     />
                  </GridItem>

                  {/* State Dropdown */}
                  <GridItem>
                     {/* {renderDynamicDropdown(
                        'stateId',
                        'State',
                        stateData,
                        {
                           value: formData.stateIds,
                           onChange: handleStateChange,
                           showCustomNoOptions: true,
                           openfrom: 'state',
                        },
                        {},
                        textColor,
                        false,
                        'Select State',
                        true,
                        undefined,
                        true,
                     )} */}
                     <MultiSelectDropdown
                        label="State"
                        options={stateData}
                        value={formData.stateIds}
                        onChange={handleStateChange}
                        placeholder="Select State"
                        isRequired={true}
                        showAddButton={false}
                        onAddNew={(value) => console.log('handleAddNew', value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={null}
                        error={''}
                     />
                  </GridItem>

                  {/* City Dropdown */}
                  <GridItem>
                     {/* {renderDynamicDropdown(
                        'cityId',
                        'City',
                        cityData,
                        {
                           value: formData.cityIds,
                           onChange: handleCityChange,
                           showCustomNoOptions: true,
                           openfrom: 'city',
                        },
                        {},
                        textColor,
                        false,
                        'Select City',
                        true,
                        undefined,
                        true,
                     )} */}
                     <MultiSelectDropdown
                        label="City"
                        options={cityData}
                        value={formData.cityIds}
                        onChange={handleCityChange}
                        placeholder="Select City"
                        isRequired={true}
                        showAddButton={false}
                        onAddNew={(value) => console.log('handleAddNew', value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={null}
                        error={''}
                     />
                  </GridItem>

                  {/* Warehouse Dropdown */}
                  <GridItem>
                     {/* {renderDynamicDropdown(
                        'warehouseId',
                        'Warehouse',
                        warehouseData,
                        {
                           value: formData.warehouseIds,
                           onChange: handleWarehouseChange,
                           showCustomNoOptions: true,
                           openfrom: 'warehouse',
                        },
                        {},
                        textColor,
                        false,
                        'Select Warehouse',
                        true,
                        undefined,
                        true,
                     )} */}
                     <MultiSelectDropdown
                        label="Warehouse"
                        options={warehouseData}
                        value={formData.warehouseIds}
                        onChange={handleWarehouseChange}
                        placeholder="Select Warehouse"
                        isRequired={true}
                        showAddButton={true}
                        onAddNew={(value) => console.log('handleAddNew', value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={warehouseForm}
                        error={''}
                     />
                  </GridItem>

                  {/* RAM Dropdown */}
                  <GridItem>
                     {/* {renderDynamicDropdown(
                        'ramId',
                        'RAM',
                        RAM_TYPE,
                        {
                           value: formData.ram,
                           onChange: (value) => handleInputChange('ram', value),
                        },
                        {},
                        textColor,
                        false,
                        'Select RAM',
                        true,
                        undefined,
                        true,
                     )} */}
                     <MultiSelectDropdown
                        label="RAM"
                        options={RAM_TYPE}
                        value={formData.ram}
                        onChange={(value) => handleInputChange('ram', value)}
                        placeholder="Select RAM"
                        isRequired={true}
                        showAddButton={false}
                        onAddNew={(value) => console.log('handleAddNew', value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={null}
                        error={''}
                     />
                  </GridItem>

                  {/* Storage Dropdown */}
                  <GridItem>
                     {/* {renderDynamicDropdown(
                        'storageId',
                        'Storage',
                        STORAGE_TYPE,
                        {
                           value: formData.storage,
                           onChange: (value) => handleInputChange('storage', value),
                        },
                        {},
                        textColor,
                        false,
                        'Select Storage',
                        true,
                        undefined,
                        true,
                     )} */}
                     <MultiSelectDropdown
                        label="Storage"
                        options={STORAGE_TYPE}
                        value={formData.storage}
                        onChange={(value) => handleInputChange('storage', value)}
                        placeholder="Select Storage"
                        isRequired={true}
                        showAddButton={false}
                        onAddNew={(value) => console.log('handleAddNew', value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={null}
                        error={''}
                     />
                  </GridItem>
               </Grid>
            </ModalBody>

            <ModalFooter>
               <Button type="submit" colorScheme="green" mr={3}>
                  Apply Filters
               </Button>
               <Button onClick={handleClear}>Reset</Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
}

export default ItemSerialWiseHistory;
